module.exports = __webpack_public_path__ + "img/icon_internet@2x.c20ef4e6.png";